/**
 * Contact Us 页面公共配置
 * 所有品牌共享的文案
 */

export const commonTexts = {
  feedbackTitle: 'Please describe your feedback',
  feedbackPlaceholder: 'Please describe your feedback',
  emailTitle: 'Enter your email',
  emailPlaceholder: 'Your email',
  submitButton: 'Submit',
  submittingButton: 'Submitting...',
  successToast: 'success',
  failToast: 'fail',
  emailErrorToast: 'Please enter the correct email address',
} as const
